import { getClient as getHttpClient } from '@zg-rentals/ts-client-http-client';
import { setClient as setSatelliteClient } from '@zg-rentals/ts-satellite-client/client';

export function configureSatelliteClient(): void {
  setSatelliteClient(getHttpClient().extend({ prefixUrl: '/rental' }));
}
